export default __webpack_public_path__ + "static/media/VELAS.072a980e.svg";